import { render, staticRenderFns } from "./BenchmarkCard.vue?vue&type=template&id=0896b4b7&scoped=true&"
import script from "./BenchmarkCard.vue?vue&type=script&lang=ts&"
export * from "./BenchmarkCard.vue?vue&type=script&lang=ts&"
import style0 from "./BenchmarkCard.vue?vue&type=style&index=0&id=0896b4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896b4b7",
  null
  
)

export default component.exports